import React from 'react';
import arrow from "../../../../styles/svg/arrow.svg";
import HistoryAvatar from './HistoryAvatar';

const AssigneeChange = ({ oldAssignee, newAssignee }) => {
  return (
    <div className="d-flex align-items-center history-heading">
      {oldAssignee && (
        <>
          <div className="history-img">
            <HistoryAvatar userData={oldAssignee} showIcon={false} />
          </div>
          <p className="mr-4">
            {oldAssignee.username} <img className="ml-4" src={arrow} alt="arrow" />
          </p>
        </>
      )}
      {newAssignee && (
        <>
          <div>
            <HistoryAvatar userData={newAssignee} showIcon={false} />
          </div>
          <p>{newAssignee.username}</p>
        </>
      )}
    </div>
  );
};

export default AssigneeChange; 